import { Component, Input } from '@angular/core';
import { HttpCommunicationService } from '../../../../service/http-communication.service';
import { BulkNotificationDto } from '../../../../service/dto';
import { FormBuilder } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
	selector: 'app-communication-confirmation-modal',
	standalone: false,
	templateUrl: './communication-confirmation-modal.component.html',
	styleUrl: './communication-confirmation-modal.component.scss'
})
export class CommunicationConfirmationModalComponent {

	@Input() bulkPayload!: BulkNotificationDto;

	constructor(
		private fb: FormBuilder,
		private httpService: HttpCommunicationService,
		private modalRef: NzModalRef,
		private message: NzMessageService) {
	}

	get recipientFilterTitle(): string {
		if (!this.bulkPayload || !this.bulkPayload.filters) {
			return 'Recipient Filters';
		}
		return 'Recipient Filters (Filters: ' 
			+ this.bulkPayload.filters.length 
			+ ' - Recipients: ' 
			+ this.bulkPayload.filterCount + ')' 
	}

	onConfirm(): void {
		this.modalRef.close(true);
	}

	onCancel(): void {
		this.modalRef.close(false);
	}

}
